import React from "react";
import { useSelector } from "react-redux";
import { constants, getSingularPluralWordForm } from "@qgiv/core-js";
import { selectAllP2pSettings } from "../../../../redux/slices/p2pSettingsSlice";
import { selectAllClassifications } from "../../../../redux/slices/classificationsSlice";
import { selectAllRegistration } from "../../../../redux/slices/registrationSlice";
import { selectCmsControlByType } from "../../../../redux/slices/cmsSettingsSlice";
import TeamRoleCardContent from "./TeamRoleCardContent";

const ConnectedTeamRoleCardContent = () => {
    const {
        ENUMS: {
            CMS_Control: { P2P_REGISTRATION_CLASSIFICATIONS },
        },
    } = constants;
    const p2pSettings = useSelector(selectAllP2pSettings);
    const classifications = useSelector(selectAllClassifications);
    const registration = useSelector(selectAllRegistration);
    const {
        classification: { Classification = [] },
    } = registration;
    const {
        classificationLimitDisplayTeamThreshold,
        enableIndividualRegistration,
    } = p2pSettings;

    const classification =
        Object.keys(registration.classification).length > 0 &&
        typeof Classification[0] === "string"
            ? classifications.find(({ id }) => `${id}` === Classification[0])
            : {};

    const {
        displayTeamSpotsLeft = false,
        registrantSpotsLeftOnAllTeams,
        teamSpotsLeft,
    } = classification;

    const control = useSelector((state) =>
        selectCmsControlByType(P2P_REGISTRATION_CLASSIFICATIONS, state),
    );

    const classificationControl = typeof control === "object" ? control : {};

    const {
        options: {
            maxNewTeamsReachedLabel = "No longer accepting new teams.",
            onlyIndividualRegistrationAvailableLabel = "All teams full. Register as individual.",
            remainingNewTeamSpotsLabel = "Only %RemainingTeamSpots% spot(s) left for new teams!",
        },
    } = classificationControl;

    const formattedTeamLimitLabel = remainingNewTeamSpotsLabel.replace(
        "%RemainingTeamSpots%",
        teamSpotsLeft,
    );

    const formattedTeamLimitReachedLabel = maxNewTeamsReachedLabel;

    const formattedOnlyIndividualRegistrationAvailableLabel =
        onlyIndividualRegistrationAvailableLabel;

    const displayTeamLimit =
        displayTeamSpotsLeft &&
        typeof teamSpotsLeft === "number" &&
        teamSpotsLeft > 0 &&
        typeof classificationLimitDisplayTeamThreshold === "number" &&
        teamSpotsLeft <= classificationLimitDisplayTeamThreshold;

    const displayOnlyIndividualRegistrationAvailable =
        enableIndividualRegistration &&
        typeof registrantSpotsLeftOnAllTeams === "number" &&
        registrantSpotsLeftOnAllTeams === 0;

    const displayTeamLimitReached =
        !displayOnlyIndividualRegistrationAvailable &&
        displayTeamSpotsLeft &&
        typeof teamSpotsLeft === "number" &&
        teamSpotsLeft === 0;

    const teamRoleCardContentProps = {
        displayOnlyIndividualRegistrationAvailable,
        displayTeamLimit,
        displayTeamLimitReached,
        formattedTeamLimitLabel: getSingularPluralWordForm(
            formattedTeamLimitLabel,
            teamSpotsLeft,
        ),
        formattedTeamLimitReachedLabel,
        formattedOnlyIndividualRegistrationAvailableLabel,
    };

    return <TeamRoleCardContent {...teamRoleCardContentProps} />;
};

export default ConnectedTeamRoleCardContent;
